import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-sub-account',
  templateUrl: './sub-account.component.html',
  styleUrls: ['./sub-account.component.scss']
})
export class SubAccountComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SubAccountComponent>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) { 
      
    }

  ngOnInit(): void {
    this.rebuildEntities();
  }

  rebuildEntities() {
    if(this.data.data.length>0){
      this.data.data.forEach(item => {
        item.realentitystatuses = [];
        let validStatus = ["Existing Business", "Potential Growth", "Not Engaged", "Unknown Status"];
        validStatus.forEach(statu => {
          let entityObj = {
            status: statu,
            num: 0,
          };
          if(item.entitystatuses&&item.entitystatuses.length>0){
            const s = item.entitystatuses.find(itm => itm.status === statu);
            if(s){
              entityObj.num = s.num;
            }
          }
          item.realentitystatuses.push(entityObj);
        });
      });
    }
  }

  close(){
    this.dialogRef.close("cancel");
  }

  redirect(account) {
    if(account.right == 1){
      let accountid=account.id;
      this.dialogRef.close("cancel");
      let o = {};    
      o['a'] = accountid;
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: o,
        queryParamsHandling: 'merge',
        skipLocationChange: false,
        replaceUrl: false
      });
    }
  }

  getStatusColor(val){
 
    if(val=="Existing Business") return "#97BE35"
    if(val=="Potential Growth") return "#F7CF2B"
    if(val=="Not Engaged") return "#FF0000"
    if(val=="Unknown Status") return "#A3A3A3"
 
     return ""    
   }

}
